import React from 'react';
import classNames from 'classnames';

const Info = ({ view, changeView, restartQuiz, scratcherPosition, numberOfQuestions, viewDetail }) =>  {

  const infoClass = classNames({
    'scene': true,
    'scene--scratcher-info': true,
    'scene--hidden': view !== 'info'
  });

  const handleRestart = e => {
    e.preventDefault();
    if(scratcherPosition > numberOfQuestions){
      restartQuiz();
    } else {
      changeView('questions', view);
    }
  }

  const detailClick = (e, slug) => {
    e.preventDefault();
    viewDetail(slug);
  }

  // set text based on whether user is in the middle of a quiz or not
  const GiftFinderButtonText = (scratcherPosition > numberOfQuestions) ? 'Start the Gift Finder' : 'Return to the Gift Finder'

  return (
    <div className={infoClass}>
      <div className="scene__content">
          <div className="scene__content-left">
              <p className="scene__p">Select any of the Holiday Games to get more information about that game.</p>
              <p className="scene__p">Or Start the Gift Finder to find the game that’s right for you!</p>
              <div className="columns">
                  <div className="columns__column">
                      <a
                        onClick={e => handleRestart(e)}
                        className="button button--white"
                        href=""
                      > {GiftFinderButtonText}
                      </a>
                  </div>
              </div>
          </div>
          <div className="scene__content-right">
          {/* TODO: Make dynamic by pulling in tickets from file and mapping to component */}
          <svg className="tickets tickets--grid" version="1.1" x="0px" y="0px" viewBox="0 0 793.3 819.9" style={{enableBackground:'new 0 0 793.3 819.9'}}>
              <a href="#" onClick={(e) => detailClick(e, 'tacky-sweater')}>
                  <image x="176.914" y="159.774" width="118" height="147.5" xlinkHref="../../../images/tickets/TackySweater.png" filter="url(#ticket-shadow--small)" />
              </a>
              <a href="#" onClick={(e) => detailClick(e, 'sneak-a-peak')}>
                  <image x="461.496" y="149.021" width="110" height="110" xlinkHref="../../../images/tickets/SneakPeek.png" filter="url(#ticket-shadow--small)" />
              </a>
              <a href="#" onClick={(e) => detailClick(e, 'seasons-winnings')}>
                  <image x="304.922" y="269.029" width="243.905" height="243.905" xlinkHref="../../../images/tickets/SeasonsWinnings.png" filter="url(#ticket-shadow--small)" />
              </a>
              <a href="#" onClick={(e) => detailClick(e, 'raffle')}>
                  <image x="178.015" y="485.957" width="116.9" height="206.822" xlinkHref="../../../images/tickets/Raffle.png" filter="url(#ticket-shadow--small)" />
              </a>
              <a href="#" onClick={(e) => detailClick(e, 'holiday-riches')}>
                  <image x="432.74" y="523.355" width="116.088" height="174.056" xlinkHref="../../../images/tickets/HolidayRiches.png" filter="url(#ticket-shadow--small)" />
              </a>
              <a href="#" onClick={(e) => detailClick(e, 'festive-50')}>
                  <image x="304.9" y="149.021" width="146.588" height="110" xlinkHref="../../../images/tickets/Festive50s.png" filter="url(#ticket-shadow--small)" />
              </a>

              <a href="#" onClick={(e) => detailClick(e, '20-years-of-cash')}>
                  <image x="306.371" y="523.279" width="116.088" height="174.131" xlinkHref="../../../images/tickets/20YearsCash.png" filter="url(#ticket-shadow--small)" />
              </a>
              <a href="#" onClick={(e) => detailClick(e, '100x-the-money')}>
                  <image x="558.835" y="269.029" width="113" height="339" xlinkHref="../../../images/tickets/100xMoney.png" filter="url(#ticket-shadow--small)" />
              </a>
              <a href="#" onClick={(e) => detailClick(e, 'chia-cash')}>
                  <image x="136.248" y="317.282" width="158.667" height="158.667" xlinkHref="../../../images/tickets/chiaCash.png" filter="url(#ticket-shadow--small)" />
              </a>
          </svg>
          </div>
      </div>
  </div>
  );
}

export default Info;



/** WEBPACK FOOTER **
 ** ./src/components/Scenes/Info/Info.js
 **/